import { connect } from 'react-redux';

import PardotConfigurationView from './PardotConfigurationView.jsx';
import { updateConfiguration} from 'src/legacy/redux/actions/integrations/pardot.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.pardot.changes.error,
    updating: state.legacyRootReducer.settings.integrations.pardot.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.pardot.changes.loading,
    user: state.users.me,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    }
  }
}

const PardotConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PardotConfigurationView);

export default PardotConfigurationPage;
